import { HardHat, Home, Handshake, Briefcase } from "lucide-react";

export const MODELOS = [
  { id: "obra_reforma", titulo: "Obra y reforma integral", otra: "Cliente", de: "del cliente", icon: HardHat,
    desc: "Reformas completas de viviendas, locales o edificios: licencias, acta de recepción y garantías de la LOE." },
  { id: "servicios_particular", titulo: "Servicios a particulares", otra: "Cliente", de: "del cliente", icon: Home,
    desc: "Reparaciones, instalaciones y trabajos puntuales para particulares, con derecho de desistimiento de 14 días." },
  { id: "subcontrata", titulo: "Subcontrata", otra: "Subcontratista", de: "del subcontratista", icon: Handshake,
    desc: "Encarga parte de una obra a otra empresa: REA, prevención de riesgos, seguro y retención de garantía." },
  { id: "servicios_subcontrata", titulo: "Servicios a empresa subcontratada", otra: "Empresa subcontratada", de: "de la empresa subcontratada", icon: Briefcase,
    desc: "Encarga servicios a otra empresa: prevención de riesgos, seguro de RC, confidencialidad y sin cesión de trabajadores." },
];
export const MODELO = Object.fromEntries(MODELOS.map((m) => [m.id, m]));
export const esSub = (tipo) => tipo === "subcontrata" || tipo === "servicios_subcontrata";

export const parteDeCliente = (c, p) => ({ ...p, nombre: c.nombre, tipo: c.tipo === "empresa" ? "empresa" : "particular", dni: c.nif || "", direccion: c.direccion || "", telefono: c.telefono || "", email: c.email || "" });

export const ESTADOS_CONTRATO = {
  borrador: { label: "Borrador", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  enviado: { label: "Pendiente de firma", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  firmado: { label: "Firmado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const FORMAS_PAGO = [
  ["transferencia", "Transferencia bancaria"], ["bizum", "Bizum"], ["tarjeta", "Tarjeta"],
  ["domiciliacion", "Domiciliación bancaria"], ["efectivo", "Efectivo (máx. 1.000 €)"], ["otro", "Otro"],
];
export const CONCEPTOS = [["senal", "Señal"], ["parcial", "Pago parcial"], ["final", "Liquidación final"]];

const pago = (concepto, descripcion) => ({ concepto, descripcion, importe: "", fecha: "" });
const hoy = () => new Date().toISOString().slice(0, 10);

export const nuevoContrato = (tipo) => {
  const serv = tipo === "servicios_particular";
  const sub = esSub(tipo);
  const obra = tipo === "subcontrata";
  const fases = tipo === "servicios_subcontrata"
    ? [pago("senal", "A la firma del contrato"), pago("parcial", "A mitad de los servicios"), pago("final", "A la recepción de los servicios")]
    : [pago("senal", "A la firma del contrato"), pago("parcial", "A mitad de los trabajos"), pago("final", "A la recepción de los trabajos")];
  return {
    tipo, cliente_id: "", subcontrata_id: "", presupuesto_id: "", obra: "",
    cliente: { nombre: "", tipo: sub ? "empresa" : "particular", dni: "", direccion: "", telefono: "", email: "", rea: "" },
    titulo: "", direccion_obra: "", descripcion: "", precio_total: "", iva_pct: obra ? 0 : 21, iva_incluido: true,
    forma_pago: "transferencia", forma_pago_detalle: "",
    pagos: serv ? [pago("senal", "A la firma del contrato"), pago("final", "Al terminar el servicio")] : fases,
    fecha_inicio: hoy(), plazo_valor: serv ? 7 : 8, plazo_unidad: serv ? "dias" : "semanas",
    garantia_meses: serv ? 6 : 12, penalizacion_pct_dia: 0.1, penalizacion_max_pct: 10, retencion_pct: obra ? 5 : 0,
    seguro_rc_importe: "", confidencialidad_anios: 2, licencias: "empresa", localidad: "", clausulas_extra: "",
  };
};

// Comprobación previa al guardar, con mensajes claros en vez de los del servidor.
export const validar = (f) => {
  if (!f.cliente.nombre.trim()) return `Escribe el nombre o la razón social ${MODELO[f.tipo].de}.`;
  if (f.cliente.email.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.cliente.email.trim())) return "El email no es válido.";
  if (f.titulo.trim().length < 3) return "Escribe el título del trabajo (mínimo 3 caracteres).";
  if (f.descripcion.trim().length < 10) return "Describe el trabajo a realizar (mínimo 10 caracteres).";
  if (!(Number(f.precio_total) > 0)) return "Indica el precio total.";
  if (!f.fecha_inicio) return "Indica la fecha de inicio estimada.";
  if (!(Number(f.plazo_valor) >= 1)) return "Indica el plazo de ejecución.";
  if (!(Number(f.garantia_meses) >= 1)) return "Indica la garantía en meses (mínimo 1).";
  return "";
};

export const aPayload = (f) => ({
  ...f,
  precio_total: Number(f.precio_total || 0), iva_pct: Number(f.iva_pct || 0), plazo_valor: Number(f.plazo_valor || 0),
  garantia_meses: Number(f.garantia_meses || 0), penalizacion_pct_dia: Number(f.penalizacion_pct_dia || 0),
  penalizacion_max_pct: Number(f.penalizacion_max_pct || 0), retencion_pct: Number(f.retencion_pct || 0),
  seguro_rc_importe: Number(f.seguro_rc_importe || 0), confidencialidad_anios: Number(f.confidencialidad_anios || 2),
  pagos: f.pagos.map((p) => ({ ...p, importe: Number(p.importe || 0) })),
});

export const fechaCorta = (iso) => (iso ? new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "");
export const fechaHora = (iso) => (iso ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
